import { MultiSelectGroup } from '../MultiselectDropdown';
import { User } from '../../../types';
import { isAdmin, isAdviseTeamManager, isSupport } from '../../../store/User';
import { INTERNAL_ROLES } from '../../../store/Role';
import { ADVISE_GROUP_TITLE, adviseGroupFor, adviseGroupsLimitedTo, adviseRoleName } from './adviseRoleGroup';
import { roleGroups } from './roleGroups';

const ROLE_TITLES: { [key: string]: string } = {
  CSM: 'Customer Success Manager',
  SDM: 'Service Delivery Manager'
};

export const roleTitle = (title: string) => ROLE_TITLES[title] || title;

export const roleName = (title: string, label: string) => {
  if (title === ADVISE_GROUP_TITLE) return adviseRoleName(label);

  return ['Support Cases', 'Inventory', 'Executive'].includes(title)
    ? `${title} - ${label.split(' ')[0]}`
    : roleTitle(title);
};

export const grantableRoleGroups = (user: User, adviseEnabled?: boolean): MultiSelectGroup[] => {
  let groups: MultiSelectGroup[];
  if (isAdviseTeamManager(user)) {
    const heldRoles = user.roles.map((role) => role.name as string);
    return adviseEnabled ? adviseGroupsLimitedTo(heldRoles) : [];
  }
  if (isAdmin(user)) {
    groups = roleGroups;
  } else {
    const allowedRoles = isSupport(user)
      ? ['Support Cases', 'Team Manager', 'Inventory', 'Executive']
      : ['Support Cases', 'Inventory'];
    groups = roleGroups.filter((role) => allowedRoles.includes(role.title));
  }
  const canGrantAdvise = isAdmin(user) || isSupport(user);
  if (adviseEnabled && canGrantAdvise) {
    groups = [...groups, adviseGroupFor(isAdmin(user))];
  }
  return groups;
};

export const canGrantInternalRole = (user: User, adviseEnabled?: boolean): boolean =>
  grantableRoleGroups(user, adviseEnabled).some(({ title, items }) =>
    items.some(({ label }) => INTERNAL_ROLES.includes(roleName(title, label)))
  );
